export default __webpack_public_path__ + "static/media/client3.545eaa97.png";